module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.a61426c6.png";